export default "__VITE_PUBLIC_ASSET__fb11eb17__"